// libs
import React, { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// components
import Image from 'shared/layouts/DetailsPage/components/ProductImage/components/Image';
import ImageSelector from 'shared/layouts/DetailsPage/components/ProductImage/components/ImageSelector';
import ProductComparison from 'shared/layouts/DetailsPage/components/ProductComparison';

// hooks
import { useSelectedSKUMedias } from 'shared/store/details/hooks/selectors';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import useInternalExp from 'shared/hooks/useInternalExp';

// selectors
import { getProductId } from 'shared/store/details/selectors';

// helpers
import { clearImagesViewed } from 'shared/layouts/DetailsPage/components/ProductImage/helpers';

function ProductImageDesktop() {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = useSelectedSKUMedias();
  const productId = useSelector(getProductId);
  const { dweb = false } = useRemoteConfig('compareProductFeature');
  const isInternal = useInternalExp();

  // on size change images might also change so resetting index to 0
  useEffect(() => {
    setSelectedImage(0);
  }, [images]);

  useEffect(() => {
    clearImagesViewed();
  }, []);

  return (
    <>
      <ImageSelector selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
      {productId && dweb && isInternal && <ProductComparison currentProductId={productId} />}
      <Image selectedImage={selectedImage} />
    </>
  );
}

export default memo(ProductImageDesktop);
